import React from 'react';
import { Stack } from '@mui/material';

import StickyFooterWrapper from '../StickyFooterWrapper';
import EventActions from './EventActions';
import { Post } from '../../../../Utils/Types/Posts';

export default function CommunicationFooter({ post }: { post: Post }) {
  return (
    <StickyFooterWrapper>
      <Stack
        spacing={3}
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
      >
        <EventActions post={post} />
      </Stack>
    </StickyFooterWrapper>
  );
}
